/** Button looks, shared by Button, ButtonLink and anything that must look like a button. */

const VARIANTS = {
  primary: "border-transparent bg-accent text-on-accent hover:bg-accent-hover",
  secondary: "border-line-default bg-surface-1 text-ink hover:border-line-strong hover:bg-surface-2/60",
  ghost: "border-transparent bg-transparent text-ink-2 hover:bg-surface-2 hover:text-ink",
  danger: "border-transparent bg-critical text-white hover:opacity-90",
};

const SIZES = {
  xs: "h-7 gap-1 px-2 text-[11.5px]",
  sm: "h-9 gap-1.5 px-3 text-[12px]",
  md: "h-10 gap-1.5 px-4 text-[12.5px]",
  lg: "h-12 gap-2 px-5 text-[13.5px]",
};

export const ICON_SIZE = { xs: "size-3.5", sm: "size-3.5", md: "size-4", lg: "size-4" };

/** The class list for a button look, for elements that cannot be a <Button> (labels, links). */
export function buttonClass({ variant = "secondary", size = "md", block = false, className = "" } = {}) {
  return `inline-flex shrink-0 items-center justify-center rounded-control border font-medium whitespace-nowrap transition-[background-color,border-color,box-shadow,color] duration-150 disabled:pointer-events-none disabled:opacity-50 ${VARIANTS[variant] ?? VARIANTS.secondary} ${SIZES[size] ?? SIZES.md} ${block ? "w-full" : ""} ${className}`;
}
